(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'Cpp',
	};

	var form_id   = 'cpp-';
	var form_name = 'form_component_data[Cpp][cabins]';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// load ships when changing the cruise line
		$('#' + form_id + 'cruise_line_id').on('change', function onCruiseLineChange(e)
		{
			var id              = $(this).val();
			var $ships_field    = $('#' + form_id + 'ship_id');
			var $sailings_field = $('#' + form_id + 'itinerary_id');

			if (!id) {
				return;
			}

			$ships_field.empty().append('<option value="">Select a Ship</option>');
			$sailings_field.empty().append('<option value="">Select a Sailing</option>');

			// get ships for the cruise line
			Adzuki.Ajax.get('/CruiseSearch/getShips/' + id).then(function getShips(response)
			{
				$.each(response, function onEachShip(id, ship_name)
				{
					$ships_field.append(
						$('<option>').text(ship_name).attr('value', id)
					);
				});
			});
		});

		// load sailings when changing the ship
		$('#' + form_id + 'ship_id').on('change', function onShipChange(e)
		{
			var id              = $(this).val();
			var $sailings_field = $('#' + form_id + 'itinerary_id');
			var url             = '/CruiseSearch/getSailings';

			if (!id) {
				return;
			}

			$sailings_field.empty().append('<option value="">Select a Sailing</option>');

			url += '/' + id + '/0/0/0/5';

			// get sailings for the ship
			Adzuki.Ajax.get(url).then(function getSailings(response)
			{
				$.each(response, function onEachSailing(key, sailing)
				{
					var id = key.split('|')[1];

					$sailings_field.append(
						$('<option>').text(sailing).attr('value', id)
					);
				});
			});
		});

		// add a new cabin
		$('.add-cabin-btn').on('click', function onAddCabinClick(e)
		{
			e.preventDefault();

			_addCabin();
		});

		// handle price change
		$('.cabin-price-field').on('pricechanged', function onPriceChange(e)
		{
			_updateTotalCost();
		});

		// click to open modal for Booking Instructions
		$('.show-terms').on('click', function openTermsModal(e)
		{
			var $modal = $('.modal');

			e.preventDefault();

			$modal.find('.modal-title').text('Booking Instructions');

			Adzuki.Ajax.get('/Cpp/getCppBookingInstructions')
			.then(function getCppBookingInstructions(response) {
				$modal.find('.modal-body').html(response);
				$modal.modal('show');
			});
		});
	};

	function _addCabin()
	{
		var $cabin_options = $('.cabins-container').find('.cabin-options');
		var $new_cabin     = $cabin_options.first().clone(true);
		var index          = $cabin_options.length;

		// no more than 3 cabin options
		if ($cabin_options.length >= 3) {
			return;
		}

		// set the correct form attributes and whatnot
		_resetFieldValues($new_cabin);
		_updateFieldIndexes($new_cabin, index);

		// handle removing the cabin
		$new_cabin.find('.close-cabin').removeClass('hidden');
		$new_cabin.find('.close-cabin-btn').on('click', function onCabinCloseClick(e)
		{
			var $self         = $(this);
			var $cabin_option = $self.parents('.cabin-options');

			e.preventDefault();

			_removeCabin($cabin_option);
		});

		// handle price updates on the cabin
		$new_cabin.find('.cabin-price-field').on('pricechanged', function onPriceChange(e)
		{
			_updateTotalCost();
		});

		$('.cabins-container').append($new_cabin);

		// we have added the cabin, hide the add button if there are 3 already
		if ($('.cabins-container').find('.cabin-options').length >= 3) {
			$('.add-cabin').addClass('hidden');
		}
	}

	function _removeCabin($cabin_option)
	{
		var $cabin_options = null;

		$cabin_option.remove();

		$cabin_options = $('.cabins-container').find('.cabin-options');

		// display button to add a new cabin
		$('.add-cabin').removeClass('hidden');

		_updateTotalCost();

		// only the first cabin left, nothing else to do here
		if ($cabin_options.length === 1) {
			return;
		}

		// update indexes
		$cabin_options.each(function onEachCabin(i, elem)
		{
			var index = parseInt($(elem).data('index'));

			// ignore the first one
			if (index === 0) {
				return true; // continue
			}

			_updateFieldIndexes($(elem), i);
		});
	}

	function _resetFieldValues($cabin_option)
	{
		// set the cabin type to 'inside'
		$cabin_option.find('.cabin-type-field').first().val('inside');

		// set the price to $0.00
		$cabin_option.find('.cabin-price-field').first().val('0.00');

		// set the confirmation number to ''
		$cabin_option.find('.conf-number-field').first().val('');
	}

	function _updateFieldIndexes($cabin_option, index)
	{
		$cabin_option.attr('data-index', index);

		$cabin_option.find('.cabin-type-field').first().attr({
			name: form_name + '[' + index + '][cabin_type]',
			id  : form_id + 'cabins-' + index + '-cabin_type',
		});

		$cabin_option.find('.cabin-price-field').first().attr({
			name: form_name + '[' + index + '][cabin_price]',
			id  : form_id + 'cabins-' + index + '-cabin_price',
		});

		// set the confirmation number to ''
		$cabin_option.find('.conf-number-field').first().attr({
			name: form_name + '[' + index + '][confirmation_number]',
			id  : form_id + 'cabins-' + index + '-confirmation_number',
		});
	}

	function _updateTotalCost()
	{
		var total_cost = 0.00;

		$('.cabin-price-field').each(function onEachPriceField(e)
		{
			var value = parseFloat($(this).val());
			total_cost += value;
		});

		$('.total-cost').html(accounting.formatMoney(total_cost));
	}
}(jQuery, window.Adzuki || {}));
